import { DialogResponse } from 'owa-confirm-dialog';
import { updateUserConfiguration } from 'owa-options-core';
import deleteFullSearchHistoryFromRestOperation from 'owa-service/lib/operation/deleteFullSearchHistoryFromRestOperation';
import { action, mutator } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';
var clearSearchHistory = action('clearSearchHistory', function (response) {
    return {
        dialogResponse: response,
        userConfig: getUserConfiguration(),
    };
});
mutator(clearSearchHistory, function (actionMessage) {
    if (actionMessage.dialogResponse === DialogResponse.ok) {
        // Issue a request to the DeleteFullSearchHistoryFromRest OWS API, but ignore
        // the result, since we can update ours anyway.
        deleteFullSearchHistoryFromRestOperation({});
        if (actionMessage.userConfig.ViewStateConfiguration) {
            actionMessage.userConfig.ViewStateConfiguration.SearchHistory = [];
        }
        updateUserConfiguration([
            {
                propertyName: 'OWA.ViewStateConfiguration',
                propertyType: 'StringArray',
                propertyValue: [],
            },
        ]);
    }
});
export default clearSearchHistory;
//# sourceMappingURL=clearSearchHistory.js.map